'use client';

import type { CheckboxProps } from '@terra/ui-design-system';
import { Checkbox } from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import { useGraphFilters } from './GraphFiltersContext';

export function GraphFilters() {
  const t = useTranslations('codeChanges.graph');
  const {
    showTechnologies,
    setShowTechnologies,
    showRepositories,
    setShowRepositories,
  } = useGraphFilters();

  const handleTechnologiesChange: CheckboxProps['onCheckedChange'] = (
    details,
  ) => setShowTechnologies(details.checked === true);

  const handleRepositoriesChange: CheckboxProps['onCheckedChange'] = (
    details,
  ) => setShowRepositories(details.checked === true);

  return (
    <Box bg="canvas" borderRadius="sm" boxShadow="sm" p={2}>
      <HStack gap={3} alignItems="center">
        <Checkbox
          checked={showTechnologies}
          onCheckedChange={handleTechnologiesChange}
          size="sm"
          colorPalette="gray"
        >
          {t('filters.technologies')}
        </Checkbox>
        <Checkbox
          checked={showRepositories}
          onCheckedChange={handleRepositoriesChange}
          size="sm"
          colorPalette="gray"
        >
          {t('filters.repositories')}
        </Checkbox>
      </HStack>
    </Box>
  );
}
